import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { FileText, Loader2 } from 'lucide-react';
import { useStore } from '@/contexts/StoreContext';
import { storeService } from '@/lib/services/store.service';
import { toast } from 'sonner';
import { sanitizeHtml } from '@/lib/sanitize';
import { Caixa } from '@/construtor/caixa';

export default function TermsOfServicePage() {
  const { store } = useStore();
  const [termsHtml, setTermsHtml] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (store?.id) {
      loadTerms();
    }
  }, [store?.id]);

  const loadTerms = async () => {
    if (!store?.id) return;

    try {
      setLoading(true);
      const data = await storeService.getTerms(store.id);

      if (data.termsOfService) {
        setTermsHtml(data.termsOfService);
      } else {
        setTermsHtml('<p class="text-muted-foreground">Termos de Serviço não configurados ainda.</p>');
      }
    } catch (error: any) {
      console.error('Erro ao carregar termos:', error);
      toast.error('Erro ao carregar os Termos de Serviço');
      setTermsHtml('<p class="text-destructive">Erro ao carregar os termos.</p>');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 md:px-6 lg:px-8 py-8">
      <Caixa id="legais.termos" miolo>
      <Card className="bg-card border-border">
        <Caixa id="legais.termos.titulo">
        <CardHeader className="border-b border-border pb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <FileText className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-foreground">Termos de Serviço</h1>
              <p className="text-sm text-muted-foreground mt-1">
                {store?.name || 'Loja'}
              </p>
            </div>
          </div>
        </CardHeader>
        </Caixa>

        <CardContent className="pt-6">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="w-8 h-8 animate-spin text-primary" />
            </div>
          ) : (
            <div
              className="prose prose-invert max-w-none
                prose-headings:text-foreground prose-headings:font-bold
                prose-p:text-muted-foreground prose-p:leading-relaxed
                prose-a:text-primary prose-a:no-underline hover:prose-a:underline
                prose-strong:text-foreground prose-strong:font-semibold
                prose-ul:text-muted-foreground prose-ol:text-muted-foreground
                prose-li:marker:text-primary
                prose-code:text-primary prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:rounded
                prose-pre:bg-background prose-pre:border prose-pre:border-border
                prose-blockquote:border-l-primary prose-blockquote:text-muted-foreground
                prose-hr:border-border"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(termsHtml) }}
            />
          )}
        </CardContent>
      </Card>
      </Caixa>
    </div>
  );
}
